import { useContext } from "react";
import { OpenDaysContext } from "../contexts/opendaysContext";

const useOpenDaysContext = () => useContext(OpenDaysContext);

export { useOpenDaysContext };
